import contactBanner from '@/assets/img/banner/contact.jpg';
import introduceBanner from '@/assets/img/banner/introduce.jpg';
import informationBanner from '@/assets/img/banner/information.jpg';
import membershipBanner from '@/assets/img/banner/membership.jpg';
import publicationBanner from '@/assets/img/banner/publication.jpg';
import societyBanner from '@/assets/img/banner/society.jpg';

/** 메가 메뉴 비주얼 — 각 섹션 SubBanner와 동일 이미지 */
export const headerMegaImages: Record<string, string> = {
	introduce: introduceBanner,
	society: societyBanner,
	membership: membershipBanner,
	publication: publicationBanner,
	submission: publicationBanner,
	information: informationBanner,
	contact: contactBanner,
};
